import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

const digits = (v) => String(v || "").replace(/\D/g, "");
const key = (phones, emails) => [...phones.map((p) => digits(p.numero || p.value)).filter((d) => d.length >= 8), ...emails.map((e) => String(e.value || e.email || "").trim().toLowerCase()).filter((e) => e.includes("@"))].join("|");

/** iter468 30.2 — avis non bloquant quand le téléphone (chiffres) ou l'e-mail (sans majuscules) correspond à un contact existant ; vérifié au blur (quand la valeur se stabilise). */
export default function DuplicateNotice({ phones = [], emails = [], excludeId, onUse, tid }) {
  const [hit, setHit] = useState(null);
  const [ignored, setIgnored] = useState("");
  const last = useRef("");
  const k = key(phones, emails);
  useEffect(() => {
    if (!k || k === last.current) { if (!k) setHit(null); return; }
    const onBlur = () => {
      if (k === last.current) return;
      last.current = k;
      const tel = phones.map((p) => p.numero || p.value).find((v) => digits(v).length >= 8) || "";
      const email = emails.map((e) => e.value || e.email).find((v) => String(v || "").includes("@")) || "";
      api.post("/crm/contacts/check-duplicate", { telephone: tel, email, exclude_id: excludeId || undefined }).then(({ data }) => setHit(data?.contact && data.contact.id !== excludeId ? data.contact : null)).catch(() => setHit(null));
    };
    document.addEventListener("focusout", onBlur, true);
    return () => document.removeEventListener("focusout", onBlur, true);
  }, [k, excludeId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!hit || ignored === hit.id) return null;
  const name = `${hit.nom || ""} ${hit.prenom || ""}`.trim();
  const btn = (color) => ({ fontSize: 10.5, padding: "3px 9px", borderRadius: 7, border: `1px solid ${color}`, background: "transparent", color: color === "#F59E0B" ? "#FCD34D" : "#C8C8CC", whiteSpace: "nowrap" });
  return (
    <div className="flex items-center flex-wrap" style={{ gap: 8, padding: "5px 10px", borderLeft: "3px solid #F59E0B", marginBottom: 8 }} data-testid={`${tid}-duplicate`} data-contact={hit.id}>
      <span style={{ fontSize: 10.5, color: "#FCD34D", flex: 1, minWidth: 160 }}>Ce contact existe déjà : <b>{name}</b> ({hit.reference || "—"})</span>
      {onUse && <button type="button" onClick={() => { onUse(hit); setIgnored(hit.id); }} style={btn("#F59E0B")} data-testid={`${tid}-duplicate-use`}>Utiliser ce contact</button>}
      <button type="button" onClick={() => setIgnored(hit.id)} style={btn("#33333B")} data-testid={`${tid}-duplicate-ignore`}>Ignorer</button>
    </div>
  );
}
